import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import * as commonActions from '@common/common.action';
import SelectComponent from '@componentes/select/select.component';
import TermoIndividualTemplate from '@common/inconformidade/modelos/termo.individual.template';
import WebapiCommon from '@common/util/webapi.common';
import {
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  CardBody,
  CardTitle,
  Card,
  CardText
} from 'reactstrap';
import { editorUrl } from '@constants/defaultValues';
import IntlMessage from '../../../../../helpers/intlMessage';
import { injectIntl } from 'react-intl';

const NConformidadePage = (props) => {
  const intl = props.intl
  const {messages} = props.intl;
  const dispatch = useDispatch();
  const [termoNConfConsolidado, setTermoNConfConsolidado] = useState({});

  const handlePrint = useReactToPrint({
    content: () => this.termoIndividualTemplateRef,
    documentTitle: termoNConfConsolidado.dadosGeraisHospital
      ? termoNConfConsolidado.dadosGeraisHospital.razaosoc
      : ''
  });

  const loadData = (historicoId, laudoId) => {
    let itensCheckboxNConf = [historicoId];
    dispatch(commonActions.showFadeCarregando(true));
    WebapiCommon.imprimirTermoAnuencia(laudoId, itensCheckboxNConf, false).then(
      response => {
        
        if (response.nConfAndTexto.texto.length > 0) {
          fetch(`${editorUrl}/Editor/ConvertRtfToHtml`, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({ text: response.nConfAndTexto.texto })
          })
            .then(r => r.json())
            .then(res => {
              response.nConfAndTexto.texto = res;

              setTermoNConfConsolidado(response);
              handlePrint();
              dispatch(commonActions.showFadeCarregando(false));
            });
        } else {
          setTermoNConfConsolidado(response);
          dispatch(commonActions.showFadeCarregando(false));
          handlePrint();
        }
      }
    );
  };

  
  return (
    <React.Fragment>
      <Modal size={'lg'} isOpen={props.open} toggle={props.toggle}>
        <div className='nconformidade'>
          <ModalHeader toggle={props.toggle}>
            {props.item.etapa === 1 && (
              <div>
                {messages['dashboards.cytology.nonconformityToBlock'] + props.item.label}
              </div>
            )}
            {props.item.etapa === 2 && (
              <div>
                {messages['dashboards.cytology.nonconformityToBlade'] + props.item.label}
              </div>
            )}
            {props.item.etapa === 3 && (
              <div>
                { messages['dashboards.cytology.nonconformityToBlade'] + props.item.label}
              </div>
            )}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.unconformities"/></Label>
                  <SelectComponent
                    options={props.naoconformidades}
                    onChange={props.onChangeInconformidade}
                    placeholder={messages['dashboards.examDetail.selectUnconformities']}
                  />
                </FormGroup>
              </Col>
              <Col sm='auto'>
                <FormGroup>
                  <Button
                    style={{ marginTop: '33px' }}
                    color='link'
                    onClick={props.adicionarNaoConformidade}
                  >
                    <i className='mv-basico-adicionar'></i>
                    <span><IntlMessage id = "dashboards.examDetail.adding"/></span>
                  </Button>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm='auto'>
                <FormGroup check className='checkbox-adicionar'>
                  <Label check>
                    <Input
                      type='checkbox'
                      checked={props.exibirNaoConformidadeNoLaudo}
                      onChange={props.exibirNaoConformidadeNoLaudoChangeValor}
                    />{' '}
                    <IntlMessage id = "dashboards.cytology.nonconformityToReport"/>
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <br />
            <div
              style={{
                height: `${props.altura - 88}px`,
                overflowY: 'scroll',
                overflowX: 'hidden'
              }}
            >
              {props.historicoNaoConf.length > 0 &&
                props.historicoNaoConf.map(item => {
                  const resolucao =
                    item.dataResolucao !== null
                      ? `(${intl.formatMessage({ id: "dashboards.histology.resolveIn" })} ${props.getDateResolucao(
                          item.dataResolucao
                        )})`
                      : `(${intl.formatMessage({ id: "dashboards.examDetails.status.pending" })})`;
                  return (
                    <Row key={item.historicoId}>
                      <Col>
                        <Card>
                          <CardBody>
                            <CardTitle>
                              {`${item.nm_Nome} ${resolucao}`}
                              {item.dataResolucao === null && (
                                <a
                                  className='mv-basico-imprimir'
                                  onClick={() => {
                                    loadData(item.historicoId, item.laudoId);
                                  }}
                                >
                                  &nbsp;
                                </a>
                              )}
                            </CardTitle>
                            <CardText>
                              {`${intl.formatMessage({ id: "dashboards.examDetails.status.pending" })}) ${props.getDateResolucao(
                                item.dataInclusao
                              )} ${intl.formatMessage({ id: "dashboards.histology.inStep" })}) `}
                              <span>{item.nomeEtapa}</span>
                            </CardText>
                            <br />
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type='checkbox'
                                  checked={item.sn_Imprimir_Nconf_Laudo === 'S'}
                                  onChange={e =>
                                    props.atualizarExibicaoNaoConformidadeNoTextoFinalLaudo(
                                      item.historicoId,
                                      e.currentTarget.checked
                                    )
                                  }
                                  readOnly={true}
                                />{' '}
                                <IntlMessage id = "dashboards.cytology.nonComplianceDisplayed"/>
                              </Label>
                            </FormGroup>
                            {item.dataResolucao === null && (
                              <div className='mt-2'>
                                <br />
                                <FormGroup className='mb-1'>
                                  <Input
                                    type='textarea'
                                    name='text'
                                    placeholder={messages['dashboards.examDetails.justification']}
                                    onChange={e => {
                                      props.setJustificativa(e.target.value);
                                    }}
                                    required
                                  />
                                </FormGroup>
                                <FormGroup className='mb-0'>
                                  <Button
                                    color='link'
                                    onClick={() => {
                                      props.resolverNaoConformidade(
                                        item.historicoId
                                      );
                                    }}
                                    disabled={!props.existeJustificativa()}
                                  >
                                    <i className='mv-basico-confirmar'></i>
                                    <IntlMessage id = "dashboards.cytology.solve"/>
                                  </Button>
                                </FormGroup>
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  );
                })}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' onClick={props.toggle}>
              <IntlMessage id = "dashboards.examDetails.cancel"/>
            </Button>
          </ModalFooter>
        </div>
      </Modal>
      <div style={{ visibility: 'hidden', position: 'fixed' }}>
        <TermoIndividualTemplate
          ref={el => (this.termoIndividualTemplateRef = el)}
          termoNConfConsolidado={termoNConfConsolidado}
          onload={() => {}}
          altura={props.altura}
        />
      </div>
    </React.Fragment>
  );
};

export default injectIntl (NConformidadePage);



// WEBPACK FOOTER //
// ./src/pages/histologia/common/modais/nconformidade/nconformidade.page.js